import React from 'react'
import styled from 'styled-components'

import SimpleA from 'components/display/SimpleAnchor'
import useFeatureFlag from 'hooks/useFeatureFlag'
import { promotionBanner } from 'featureFlags'

const Message = styled.p`
  text-align: center;
  margin: auto;
  font-weight: 400;
  line-height: 1.4;
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};

  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};

  a {
    color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
    &:hover,
    &:link {
      color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
    }
  }
`

const Outer = styled.div`
  z-index: 1;
  box-sizing: border-box;
  width: 100%;
  padding: 16px;

  background-color: ${({ theme }) => theme?.['-ds-warning-200']?.value};
`

const marketOfferPaths = {
  NSW: '/collections/Black-Friday-Cyber-Monday-NSW',
  VIC: '/collections/Black-Friday-Cyber-Monday-VIC',
  NZ: '/collections/Black-Friday-Cyber-Monday-NZ',
} as const

type Props = {
  marketCode: GQL_MarketCode
}

const PromoBanner = ({ marketCode }: Props) => {
  const hasFeatureFlag = useFeatureFlag(promotionBanner)

  if (hasFeatureFlag !== true) {
    return null
  }

  if (marketCode !== 'NSW' && marketCode !== 'VIC' && marketCode !== 'NZ') {
    return null
  }

  const offersPath = marketOfferPaths[marketCode]

  return (
    <Outer>
      <Message>
        <strong>Black Friday to Cyber Monday sale on now!</strong> 25% off
        selected escapes.{' '}
        <SimpleA textDecoration="underline" href={offersPath}>
          View offers
        </SimpleA>
      </Message>
    </Outer>
  )
}

export default PromoBanner
